import { render } from "./ManagerProductCard.vue?vue&type=template&id=4a4e53ad&scoped=true"
import script from "./ManagerProductCard.vue?vue&type=script&lang=js"
export * from "./ManagerProductCard.vue?vue&type=script&lang=js"

import "./ManagerProductCard.vue?vue&type=style&index=0&id=4a4e53ad&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a4e53ad"]])

export default __exports__